import { CustomDrawer } from "../../common/components/Drawer/CustomDrawer";
import { LevageForm } from "./components/levage/LevageForm";
import { LFTableV3 } from "../../common/components/LFTable/LFTableV3";
import { useEffect, useState } from "react";
import { ColumnItem } from "../../common/models/table";
import { ActionsKey } from "../../common/models/Actions";
import { MaterialService } from "./core/_request";
import { HttpStatusCode } from "axios";
import {
  useLevageMaterialListState,
  useLevageMaterialStore,
} from "./store/LevageStore";
import { Loader } from "../../common/components/Loader/Loader";
import {
  useQueryLiftingMaterialTypeSelect,
  useQueryMachineMaterialFromSelect,
  useQueryMachineMaterialStateSelect,
} from "./core/_hooks";
import { getStateTagData } from "../../utilities/StateTag";
import { Form, InputNumber, Tag, Tooltip } from "antd";
import { GrTransaction } from "react-icons/gr";
import { LevageMovement } from "./LevageMovement";
import { MdAddShoppingCart } from "react-icons/md";
import CustomModal from "../../common/components/Modal/CustomModal";
import { FormProvider } from "../../common/provider/form/Form.provider";
import { CustomButton } from "../../common/components/CustomButton/CustomButton";
import { SimpleInput } from "../../common/components/simpleInput";
import { InputSelect } from "../../common/components/InputSelect/InputSelect";
import TextArea from "antd/es/input/TextArea";

type PropsType = {
  isShowForm: boolean;
  onShowAddHandler: () => void;
};

export const LevageList = ({ isShowForm, onShowAddHandler }: PropsType) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isShowDetail, setIsShowDetail] = useState<boolean>(false);
  const [isShowAppro, setIsShowAppro] = useState<boolean>(false);

  const [selectedItem, setSelectedItem] = useState<any>(null);

  // const { data: stateOptions, isLoading: isLoadingState } =
  //   useQueryMachineMaterialStateSelect({}, false);
  const { data: fromOptions, isLoading: isLoadingFrom } =
    useQueryMachineMaterialFromSelect({}, false);
  const { data: typeOptions, isLoading: isLoadingType } =
    useQueryLiftingMaterialTypeSelect({}, false);

  const {
    levageMaterialList,
    setLevageMaterialList,
    totalItems,
    actioned,
    setActioned,
  } = useLevageMaterialStore();

  const { pageState, setPageState, resetPageState } =
    useLevageMaterialListState();

  const cols: ColumnItem[] = [
    {
      key: "reference",
      title: "Référence",
      dataIndex: "reference",
      show: true,
      isCanSort: true,
      searchType: "text",
    },
    {
      key: "quantityTxt",
      title: "Quantité(s)",
      dataIndex: "quantityTxt",
      show: true,
    },
    // {
    //   key: "materialState",
    //   title: "Etat",
    //   dataIndex: "materialState",
    //   show: true,
    //   nestedKey: "materialState",
    //   searchType: "select",
    //   searchOptions: stateOptions,
    //   isLoading: isLoadingState,
    //   render: (state: any) => {
    //     const { label, color } = getStateTagData(state?.id);
    //     return (
    //       <div className="h-100 w-100 d-flex align-items-center justify-content-center">
    //         <Tag color={color}>{label}</Tag>
    //       </div>
    //     );
    //   },
    // },
    {
      key: "materialFrom",
      title: "Propriétaire",
      dataIndex: "materialFrom",
      show: true,
      searchType: "select",
      nestedKey: "materialFrom",
      searchOptions: fromOptions,
      isLoading: isLoadingFrom,
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name}</span>
          </div>
        );
      },
    },
    {
      key: "liftingMaterialType",
      title: "Type",
      dataIndex: "liftingMaterialType",
      show: true,
      searchType: "select",
      nestedKey: "liftingMaterialType",
      searchOptions: typeOptions,
      isLoading: isLoadingType,
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name}</span>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    fetchAllMaterialLevage(pageState);
  }, [pageState]);

  useEffect(() => {
    if (!isShowForm) {
      setActioned({ action: "no", data: null });
    }
  }, [isShowForm]);

  const onActionClick = (item: any, action: ActionsKey) => {
    if (action === "delete") {
      onDeleteHandler(item?.id);
      console.log(item?.id);
    } else {
      getOne(item?.id, action);
    }
  };

  const onShowMovment = () => {
    setIsShowDetail((prev: boolean) => !prev);
  };

  const onShowAppro = () => {
    setIsShowAppro((prev: boolean) => !prev);
  };
  const getOne = async (id: number, action: any) => {
    try {
      setIsLoading(true);
      const res = await MaterialService.getOneLevageMaterial(id);
      if (res?.status === HttpStatusCode.Ok) {
        setActioned({
          data: {
            ...res?.data,
          },
          action,
        });
      }

      onShowAddHandler();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onDeleteHandler = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await MaterialService.deleteLevageMaterial(id);
      if (res?.status === HttpStatusCode.NoContent) {
        fetchAllMaterialLevage();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAllMaterialLevage = async (params?: any) => {
    try {
      setIsLoading(true);
      const res = await MaterialService.getLevageMaterial(params);
      if (res?.status === HttpStatusCode.Ok) {
        setLevageMaterialList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onFinishAction = () => {
    resetPageState();
    onShowAddHandler();
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  const onClickOnMovement = (row: any) => {
    setSelectedItem(row);
    onShowMovment();
  };

  const onClickOnApprovisionmentStock = (row: any) => {
    setSelectedItem(row);
    onShowAppro();
  };

  return (
    <div>
      <Loader isLoading={isLoading} />

      <div className="mt-4">
        {/* Table section  */}
        <div className="">
          <LFTableV3
            columns={cols}
            data={levageMaterialList}
            params={pageState}
            onAction={onActionClick}
            isCanEdit={() => true}
            isCanDelete={() => true}
            onSearch={handleSetParams}
            onSort={handleSetParams}
            onResetSearch={resetPageState}
            pagination={{
              defaultCurrentPage: pageState.page,
              itemsPerPage: pageState?.itemsPerPage,
              totalItems: totalItems,
            }}
            onChangePage={handleSetParams}
            otherActions={[
              ({ row }) => (
                <Tooltip title={"Mouvements"}>
                  <div
                    className=" cursor-pointer"
                    onClick={() => {
                      onClickOnMovement(row);
                    }}
                  >
                    <GrTransaction />
                  </div>
                </Tooltip>
              ),
              ({ row }) => (
                <Tooltip title={"Approvisionnement stock"}>
                  <div
                    className=" cursor-pointer"
                    onClick={() => {
                      onClickOnApprovisionmentStock(row);
                      //   onClickOnMovement(row);
                    }}
                  >
                    <MdAddShoppingCart />
                  </div>
                </Tooltip>
              ),
            ]}
          />
        </div>
      </div>

      {/* Drawer section  */}
      {isShowForm ? (
        <CustomDrawer
          isOpen={isShowForm}
          onClose={onShowAddHandler}
          title={actioned?.action === "update" ? "Modification" : "Nouveau"}
          width={"75%"}
        >
          <LevageForm
            onFinish={onFinishAction}
            {...(actioned?.action === "update"
              ? {
                  initialValue: actioned?.data,
                }
              : {})}
          />
        </CustomDrawer>
      ) : (
        ""
      )}
      {isShowDetail ? (
        <CustomDrawer
          isOpen={isShowDetail}
          onClose={onShowMovment}
          title={"Mouvements"}
          width={"75%"}
        >
          <LevageMovement initialValue={selectedItem} />
        </CustomDrawer>
      ) : (
        ""
      )}
      {isShowAppro ? (
        <CustomModal
          isOpen={isShowAppro}
          hanldeCloseModal={onShowAppro}
          title={"Approvisionnement stock"}
        >
          <ApprovisionmentStockForm
            selected={selectedItem}
            onFinish={() => {
              onShowAppro();
              fetchAllMaterialLevage();
            }}
          />
        </CustomModal>
      ) : (
        ""
      )}
    </div>
  );
};

const ApprovisionmentStockForm = ({
  selected,
  onFinish,
}: {
  selected: any;
  onFinish: () => void;
}) => {
  const [form] = Form.useForm();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  const onSubmitHandler = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const dataToPost = {
        ...values,
        quantity: values?.quantity?.toString(),
        material: selected ? selected?.["@id"] : null,
        movementType: values?.movementType ? values?.movementType?.value : null,
      };

      const res = await MaterialService.createLevageApprovisionment(dataToPost);
      if (res?.status === HttpStatusCode.Created) {
        onFinish();
        form?.resetFields();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };
  return (
    <div className="">
      <FormProvider
        Form={Form}
        form={form}
        debug={true}
        onFinish={(values: any) => {
          onSubmitHandler(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="d-flex flex-column g-3">
          <SimpleInput
            Form={Form}
            label="Type de mouvement"
            name={"movementType"}
            rules={[
              {
                required: true,
                message: `Ce champ est requis`,
              },
            ]}
            customInput={
              <InputSelect
                className="w-100 mb-2"
                uri="/api/material_movement_types/select"
                params={{
                  type: "entry",
                }}
                onChange={(e) => {
                  console.log("aaaa", e);
                }}
              />
            }
          />
          <SimpleInput
            Form={Form}
            label="Quantité"
            name={"quantity"}
            rules={[
              {
                required: true,
                message: `Ce champ est requis`,
              },
            ]}
            customInput={<InputNumber className="w-100 mb-2" min={0} />}
          />
          <SimpleInput
            Form={Form}
            label="Commentaire"
            name={"comment"}
            customInput={<TextArea className="w-100 " />}
          />
        </div>
        <div className="w-100 d-flex justify-content-end my-2">
          <CustomButton type="submit" isLoading={isLoadingSubmit}>
            Enregistrer
          </CustomButton>
        </div>
      </FormProvider>
    </div>
  );
};
